import { Room, RoomDraft } from "../../proto/Global_pb";

export const SET_DRAFT_TEXT = "SET_DRAFT_TEXT";
export const SET_DRAFTS = "SET_DRAFTS";
export const SET_DRAFT_ROOM = "SET_DRAFT_ROOM";
export const CLEAR_DRAFT = "CLEAR_DRAFT";

export type IDraftStateType = {
  [key in Room.AsObject["id"]]: Room.AsObject["draft"];
};

export type setDraftTextType = {
  type: typeof SET_DRAFT_TEXT;
  payload: {
    roomId: Room.AsObject["id"];
    // draft: {message?: RoomDraft.AsObject['message'],replyTo};
    draft: Partial<Room.AsObject["draft"]>;
  };
};

export type setDraftsType = {
  type: typeof SET_DRAFTS;
  payload: IDraftStateType;
};

export type setDraftRoomType = {
  type: typeof SET_DRAFT_ROOM;
  payload: IDraftStateType;
};

export type clearDraftType = {
  type: typeof CLEAR_DRAFT;
  payload: Room.AsObject["id"];
};

export type IEditorActionTypes = setDraftTextType | setDraftsType | setDraftRoomType | clearDraftType;
